import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import { debounce } from 'lodash';
const INITIAL_STATE = {
  currentHoveredTitle: null,
  mostRecentHoveredTitle: null,
  isAnySectionHovered: false
};
const useIsTitleOrSectionHovered = () => {
  const $ = _c(5);
  const [state, setState] = useState(INITIAL_STATE);
  const {
    currentHoveredTitle,
    mostRecentHoveredTitle,
    isAnySectionHovered
  } = state;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = debounce((id, isHovered) => {
      if (isHovered) {
        setState(prevState => ({
          ...prevState,
          currentHoveredTitle: id,
          mostRecentHoveredTitle: id
        }));
      } else {
        setState(_temp);
      }
    }, 150, {
      leading: false,
      trailing: true
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setIsTitleHovered = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isHovered_0 => {
      if (isHovered_0) {
        setState(_temp2);
      } else {
        setTimeout(() => {
          setState(_temp3);
        }, 200);
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setIsSectionHovered = t1;
  const selectedItem = currentHoveredTitle || isAnySectionHovered ? mostRecentHoveredTitle : null;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setState(INITIAL_STATE);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const resetIsTitleOrSectionHovered = t2;
  let t3;
  if ($[3] !== selectedItem) {
    t3 = {
      resetIsTitleOrSectionHovered,
      selectedItem,
      setIsTitleHovered,
      setIsSectionHovered
    };
    $[3] = selectedItem;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default useIsTitleOrSectionHovered;
function _temp(prevState_0) {
  return {
    ...prevState_0,
    currentHoveredTitle: null
  };
}
function _temp2(prevState_1) {
  return {
    ...prevState_1,
    isAnySectionHovered: true
  };
}
function _temp3(prevState_2) {
  return {
    ...prevState_2,
    isAnySectionHovered: false
  };
}